import Vue from 'vue'

import Pager from './Pager'
Vue.component('Pager', Pager)



// WEBPACK FOOTER //
// ./src/assemblys/assemblys.js